import types from './types';
import create from '~/misc/create';

const toggleBackhaul = (key) => create(types.BACKHAUL_TOGGLED, key);
const viewBackhaulLane = (identity) => create(types.BACKHAUL_LANE_VIEWED, identity);

export {toggleBackhaul, viewBackhaulLane};



// WEBPACK FOOTER //
// ./src/modules/backhaul/actions.js